import React from 'react';
import { X, Info } from 'lucide-react';
import { SacredArtpiece } from '../../constants/sacredArt';

interface SacredArtFullscreenModalProps {
  artpiece: SacredArtpiece;
  isOpen: boolean;
  onClose: () => void;
  onShowInfo: () => void;
}

export const SacredArtFullscreenModal: React.FC<SacredArtFullscreenModalProps> = ({
  artpiece,
  isOpen,
  onClose,
  onShowInfo
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-95 flex items-center justify-center z-50 p-2 sm:p-4">
      {/* Close Button */}
      <button
        onClick={onClose}
        className="absolute top-4 right-4 p-2 bg-white bg-opacity-20 hover:bg-opacity-30 rounded-full transition-colors z-10"
        aria-label="Close"
      >
        <X className="w-6 h-6 text-white" />
      </button>

      {/* Info Button */}
      <button
        onClick={onShowInfo}
        className="absolute top-4 left-4 p-2 bg-white bg-opacity-20 hover:bg-opacity-30 rounded-full transition-colors z-10 flex items-center gap-2"
        aria-label="Show artwork info"
        title="Learn more about this artwork"
      >
        <Info className="w-6 h-6 text-white" />
      </button>

      {/* Image Container */}
      <div className="w-full h-full flex items-center justify-center relative">
        <img
          src={`/sacred-art/${artpiece.filename}`}
          alt={artpiece.title}
          className="max-w-full max-h-full object-contain"
          loading="lazy"
        />
      </div>

      {/* Image Info Bar */}
      <div className="absolute bottom-0 left-0 right-0 bg-black bg-opacity-70 text-white p-4 sm:p-6">
        <h2 className="text-xl sm:text-2xl font-bold">{artpiece.title}</h2>
        <p className="text-sm sm:text-base text-gray-300">{artpiece.artist}</p>
        {artpiece.year && (
          <p className="text-xs sm:text-sm text-gray-400">{artpiece.year}</p>
        )}
      </div>
    </div>
  );
};
